import { Fragment, useEffect, useState } from 'react';
import * as Yup from 'yup'
import {ErrorMessage, useFormikContext} from 'formik'
import { ApplicationFileDownload, FileUploader, FileUploaderResponse, FormikTextInput, FormikNotesArea } from '../../../../../components/widgets';
import { VerdictSelector } from '../../../../../components/layout';


export const initDLMQuotationApproveValues = {
  approved: false,
  note: '',
  quotations: [],
  numEndorsed: 0,
  noteAttachments: [],
}

export const DLMQuotationApproveSchema:any = Yup.object({
  approved: Yup.boolean(),
  note: Yup.string().trim().label('Note').when('approved', {
    is: (val: boolean) => (val === false),
    then: (schema) => schema.required('Reason is required.'),
  }),

  quotations: Yup.array().of(
  Yup.object().shape({
    endorsedQuotationAttachmentId: Yup.number().integer(),
    endorsedQuotationAttachmentName: Yup.string().trim(),
    poAttachmentId: Yup.number().integer(),
    poAttachmentName: Yup.string().trim()
    .when('poNumber', {
      is: (val: string) => (val && val.length > 0),
      then: (schema) => schema.required('PO Attachment is required.'),
    }),
    poNumber: Yup.string().trim()
    .when('poAttachmentId', {
      is: (val: number) => (val > 0),
      then: (schema) => schema.required('PO Number is required.'),
    }),
  })
  ),
  numEndorsed: Yup.number().integer().label('Endorsed Quotations')
  .when('approved', {
    is: (val: boolean) => (val === true),
    then: (schema) => schema.min(1, 'Need at least 1 endorsed quotation').required(),
  }),
  noteAttachments: Yup.array(),
});

const DLMQuotationApproveForm = () => {
  
  const {setFieldValue, validateField, values, setTouched, setStatus} = useFormikContext();
  const [ verdict, setVerdict] = useState<string | null>(null);

  useEffect(() => {
    setFieldValue('approved', verdict && verdict === 'approved' ? true : false);
  // eslint-disable-next-line  
  }, [verdict]);
  
  return (    
  <>    
  <VerdictSelector
    verdict={verdict}
    setVerdict={setVerdict}
    setFieldValue={setFieldValue}
    setStatus={setStatus}
  />

  <div className="row mb-4">
    <h3>Quotations</h3>
    { (verdict === 'approved') &&
    <>
    <div className="fs-7 text-muted">Need at least one Endorsed Quotation and/or Purchase Order.</div>
    <div className='text-danger mt-2'>
      <ErrorMessage name='numEndorsed' />
    </div>
    </>
    }
    { (verdict === 'rejected') &&
    <div className="fs-7 text-muted">Please provide reason for rejection.</div>
    }
    <div className="table-responsive">
      <table className='table align-middle table-row-bordered table-row-gray-300 fs-7 gy-2 dataTable no-footer' >
        <thead>
          <tr>
            <th colSpan={2}>Quotation</th>
            <th>Quotation Number</th>
          </tr>
        </thead>
        <tbody>
        { /* @ts-ignore */
        values?.quotations && values.quotations.map( (elem, idx: number) => (
          <Fragment key={`quoterow${idx}`}>
          <tr >
            <td colSpan={2}>
              <ApplicationFileDownload file={elem.quotationAttachment} />
            </td>
            <td>
              <span className="fs-7">{`${elem.quotationNumber}`}</span>
            </td>
          </tr>
          { (verdict === 'approved') &&
          <tr>
            <td>
              <FileUploader
                mainTitle="Endorsed Quotation"
                subTitle={ elem.endorsedQuotationAttachmentName ? elem.endorsedQuotationAttachmentName : "Click or drop here to upload."}
                fileName={ elem.endorsedQuotationAttachmentName }
                allowMultiple={false}
                acceptFiles="ApplicantFileFormats"
                onFileUploaded={ (dat: FileUploaderResponse) => {
                  setFieldValue(`quotations.${idx}.endorsedQuotationAttachmentId`, dat.id, false);
                  setFieldValue(`quotations.${idx}.endorsedQuotationAttachmentName`, dat.name, false);
                  // @ts-ignore
                  let numEndorsed = values.quotations.reduce((accumulator, currentValue, currentIndex) => {
                      return accumulator + (currentIndex !== idx && currentValue.endorsedQuotationAttachmentId > 0 ? 1 : 0)
                  },0) + 1;
                  setFieldValue('numEndorsed', numEndorsed);
                  setTouched({numEndorsed : true}, true);
                  setTimeout(() => {
                      validateField('numEndorsed');
                  }, 100);
                }}
                onClearFile={ () => {
                  setFieldValue(`quotations.${idx}.endorsedQuotationAttachmentId`, 0, false);
                  setFieldValue(`quotations.${idx}.endorsedQuotationAttachmentName`, '', false);
                  setFieldValue(`quotations.${idx}.poAttachmentId`, 0, false);
                  setFieldValue(`quotations.${idx}.poAttachmentName`, '', false);
                  // @ts-ignore
                  let numEndorsed = values.quotations.reduce((accumulator, currentValue, currentIndex) => {
                      return accumulator + (currentIndex !== idx && currentValue.endorsedQuotationAttachmentId > 0 ? 1 : 0)
                  },0);
                  setFieldValue('numEndorsed', numEndorsed, true);
                  setTouched({numEndorsed : true}, true);
                  setTimeout(() => {
                      validateField('numEndorsed');
                  }, 100);
                }}
              />
            </td>
            <td>
              { (elem.endorsedQuotationAttachmentId > 0) &&
              <FileUploader
                mainTitle="Purchase Order"
                subTitle={ elem.poAttachmentName ? elem.poAttachmentName : "Click or drop here to upload."}
                fileName={ elem.poAttachmentName }
                allowMultiple={false}
                acceptFiles="ApplicantFileFormats"
                onFileUploaded={ (dat: FileUploaderResponse) => {
                  setFieldValue(`quotations.${idx}.poAttachmentId`, dat.id, false);
                  setFieldValue(`quotations.${idx}.poAttachmentName`, dat.name, false);
                }}
                onClearFile={ () => {
                  setFieldValue(`quotations.${idx}.poAttachmentId`, 0, false);
                  setFieldValue(`quotations.${idx}.poAttachmentName`, '', false);
                  setTimeout(() => validateField("quotations"), 100)
                }}
              />
              }
            </td>
            <td>
              { (elem.poAttachmentId > 0) &&
              <FormikTextInput size="12" label="PO Number" name={`quotations.${idx}.poNumber`} required={true} />
              }
            </td>
          </tr>
          }
          </Fragment>
        ))}
        </tbody>
      </table>
    </div>
  </div>

  <FormikNotesArea label={verdict === 'rejected' ? "Reason" : "Comments"} required={verdict === 'rejected'} />
  
  </>
  )
}

export {DLMQuotationApproveForm}